import type { ProblemValidation } from '@backmarket/http-api/src/api-models/ProblemValidation'

export function isValidationError(error: unknown): error is ProblemValidation {
  // E.g. for CORS errors we could end up with empty array of errors
  return Boolean(error && (error as Record<string, string>)?.errors?.length)
}
